export default "__VITE_ASSET__C5aKw5vE__"